import type { TwillMedia } from '@/models/twill';

export enum ChatState {
  Empty = 'empty',
  Splash = 'splash',
  Home = 'home',
  Chat = 'chat'
}

export enum ChameleonState {
  Idle = 'idle',
  Searching = 'searching',
  Found = 'found',
  Accepted = 'accepted',
  Declined = 'declined',
  Error = 'error'
}

export interface CustomEmoji {
  id: string;
  name?: string | null;
}
export interface UnicodeEmoji {
  name: string;
}

export interface UserResponse {
  id: string;
  username?: string | null;
}
export type MessageReactionEmojiResponse = UnicodeEmoji | CustomEmoji;

export interface MessageResponse {
  id: string;
  channel_id: string;
  author: UserResponse;
  content: string;
  timestamp: string;
  default_reaction_emojis?: MessageReactionEmojiResponse[] | null;
  loading?: boolean | null;
  emojis?: MessageReactionEmojiResponse | null;
  event?: string;
  chameleonApprove?: boolean;
  chameleonError?: boolean;
  chameleonErrorRetryFn?: () => void;
  chameleonUrl?: string;
  chameleonTitle?: string;
  chameleonImage?: string;
  chameleonDescription?: string;
  chameleonDeclined?: boolean;
}

export interface MessageContentAddResponse {
  id: string;
  channel_id: string;
  content: string;
  message_id: string;
}

export interface MessageReactionAddResponse {
  id: string;
  channel_id: string;
  content: string;
  message_author_id: string;
  message_id: string;
  user_id: string;
  emoji: MessageReactionEmojiResponse;
}

export interface MessageWithReactionsResponse extends MessageResponse {
  reactions?: MessageReactionResponse[] | null;
}

export interface MessageReactionResponse {
  emoji: MessageReactionEmojiResponse;
  me?: boolean | null;
}

export interface StarterBlockData {
  title: string;
  description?: string;
}

export interface ChatBgShapeConfig {
  initialStart: any;
  initialEnd: any;
  chameleonStart: any;
  chameleonEnd: any;
}

export interface ChatInfoBarSearchData {
  channelId: string;
  companyName?: string;
  companyUrl?: string;
}

export interface ChatMessageSearchData {
  channelId: string;
  msg_content: string;
  message_nonce?: string;
}

export interface ChameleonPollData {
  channelId: string;
  company: string;
  companyUrl: string;
  openGraphData: any;
  status: ChameleonPollStatus;
}

export enum ChameleonPollStatus {
  Searching = 'searching',
  Founded = 'found',
  NotFound = 'not_found'
}

export interface ChameleonApproveData {
  channelId: string;
  primaryColor: string;
  secondaryColor: string;
  status: string;
  teaorImage?: TwillMedia;
}
